module.exports = __webpack_public_path__ + "static/media/GTBSProjectPreview2w1100@2x.24145680.jpeg";